import {useScopeTranslation} from '@uigstudio/uig-nextjs-helper';

import OpenSeaIcon from '~assets/images/icons/ui/opnesea.svg';
import env from '~utils/env';

import {Link} from './styles';

const OpenSeaButton = ({id}: {id: number}) => {
    const t = useScopeTranslation('common');
    return (
        <Link
            href={`${env('PLOTS_OPENSEA')}${id}`}
            target="_blank"
            rel="noopener noreferrer"
            onClick={(e) => {
                e.stopPropagation();
            }}
        >
            <OpenSeaIcon />
            {t('seeOpensea')}
        </Link>
    );
};

export default OpenSeaButton;
